import { Box } from '@mui/material';
import { FormOption } from 'common/form';
import { addToWorkflowDrawerSx } from 'modules/candidate-profile/styles/addToWorkflowDrawerSx';
import { formatDateFromNowAbbreviated } from 'utils/datetime';

type SearchedWorkflow = {
  id: string;
  name: string;
  updatedAt: string;
  liveWorkflowVersion?: { versionNumber?: number | null } | null;
  createdByUser?: { name?: string | null } | null;
};

export const toWorkflowOption = (workflow: SearchedWorkflow): FormOption => ({
  label: workflow.name,
  subLabel: [
    // Also in the row, not just the button's endItem: DropdownList renders label and
    // subLabel only, so the pill alone would leave the open list without a version.
    workflow.liveWorkflowVersion?.versionNumber
      ? `Live v${workflow.liveWorkflowVersion.versionNumber}`
      : undefined,
    `Updated ${formatDateFromNowAbbreviated(workflow.updatedAt)}`,
    workflow.createdByUser?.name
      ? `owned by ${workflow.createdByUser.name}`
      : undefined
  ]
    .filter(Boolean)
    .join(' · '),
  endItem: workflow.liveWorkflowVersion?.versionNumber ? (
    <Box sx={addToWorkflowDrawerSx.liveVersionPill}>
      Live v{workflow.liveWorkflowVersion.versionNumber}
    </Box>
  ) : undefined,
  value: workflow.id
});
